import {
  Avatar,
  Badge,
  Box,
  Card,
  Grid,
  List,
  ListItemButton,
  Paper,
  Radio,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import axios from "axios";
import { BusinessCenterRounded, LaunchRounded } from "@mui/icons-material";
import moment from "moment";
import Key from "../../../../src/clientVariables.json";

const ResumesList = ({ resumeSelectionData, resRefresh }) => {
  const {
    userSubmissions,
    candidateSubmissions,
    candidates,
    selectedCandidate,
    submissionsByJob,
    selectedJob,
    selectedSubmission,
  } = useSelector(appSelector);
  const [resumes, setResumes] = useState([]);
  const [selectedResume, setSelectedResume] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops

  const controlProps = (item) => ({
    checked: selectedResume && selectedResume.resume_id === item.resume_id,
    onChange: () => handleFileChange(item),
    value: item.resume_id,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item.resume_id },
  });

  const handleFileChange = (item) => {
    setSelectedResume(item);
    resumeSelectionData(item);
  };

  useEffect(() => {
    setSelectedResume(null);
    const fetch = async () => {
      try {
        if (selectedCandidate?.candidate_id) {
          const response = await axios.post(
            `${Key.domain}/common/get_candidate_resumes_list`,
            {
              candidate_id: selectedCandidate.candidate_id,
              user_id: selectedCandidate.user_id,
            }
          );
          setResumes(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetch();
  }, [selectedCandidate, resRefresh === true]);

  return (
    <Paper
      elevation={2}
      sx={{
        height: window.innerHeight - 150,
        overflow: "scroll",
        padding: "6px",
      }}
    >
      <Grid container spacing={2}>
        {/* {resumes.map((resume) => 
            <ListItemButton
            key={resume.resume_id}
            // selected={selectedJob.id === job.id}
            
            sx={{
              // borderBottom: "1px solid #ddd" ,
              ".hide-icons": {
                display: "none",
              },
              "&:hover": {
                ".hide-icons": {
                  display: "block",
                },
              },
            }}
          >
            <div style={{ display: "flex", gap: 10, width: "100%" }}>
              <Avatar
                sx={{
                  height: isDesktopSmall ? "24px" : "35px",
                  width: isDesktopSmall ? "24px" : "35px",
                }}
              >
                <BusinessCenterRounded
                  sx={{
                    color: "#fff",
                    height: isDesktopSmall ? "16px" : "20px",
                    width: isDesktopSmall ? "16px" : "20px",
                  // fontSize:20
                  }}
                />
              </Avatar>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Stack direction="column">
                  <Typography
                    sx={{
                      fontSize: isDesktopLarge ? "12px" : "10px",
                      fontWeight: 600,
                      margin: 0,
                      minWidth: isDesktopLarge ? "150px" : "110px",
                      maxWidth: isDesktopLarge ? "150px" : "110px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {resume?.application_title}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: isDesktopLarge ? "12px" : "9px",
                      margin: 0,
                    }}
                  >
                    {resume.full_name}
                  </Typography>
                </Stack>
                <Tooltip title="Send Job" arrow placement="top">
                  <LaunchRounded
                    className="hide-icons"
                    sx={{ fontSize: "16px", "&:hover": { bgcolor: "#fff" } }}
                    // onClick={() => {setSendJobFormOpen(true); dispatch(selectedJobAction(job)); }}
                  />
                </Tooltip>
              </Box>
            </div>
          </ListItemButton>
        )} */}
        {resumes.map((resume, index) => (
          <Grid item sm={12} key={index}>
            <Card
              sx={{
                boxShadow: "none",
                borderRadius: "8px",
                border: "1px solid #ddd",
              }}
            >
              <Grid container>
                <Badge
                  color="primary"
                  badgeContent="Primary Resume"
                  invisible={resume?.isPrimary != 1} // Show only if primary
                  sx={{
                    "& .MuiBadge-badge": {
                      left: 315,
                      top: 5,
                      backgroundColor: "#406882",
                      color: "#fff",
                      fontSize: "0.65rem",
                      height: "20px",
                      borderRadius: "4px",
                      padding: "0 4px",
                      marginTop: "5px",
                      width: "100px",
                      textTransform: "uppercase",
                    },
                  }}
                ></Badge>
                <Grid
                  item
                  xs={2}
                  sx={{
                    bgcolor: resume.filetype === "pdf" ? "#d32f2f" : "#1976d2",
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {resume.filetype === "pdf" ? "PDF" : "Docs"}
                </Grid>
                <Grid item xs={8} sx={{ p: 2 }}>
                  <Typography
                    paragraph
                    sx={{
                      mb: 0,
                      fontWeight: 500,
                      fontSize: "14px",
                      minWidth: isDesktopLarge ? "150px" : "110px",
                      maxWidth: isDesktopLarge ? "150px" : "110px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {resume.filename}
                  </Typography>
                  <Typography
                    paragraph
                    sx={{ mb: 0, fontSize: "12px", color: "#757575" }}
                  >
                    {resume.created !== undefined && resume.created !== null
                      ? moment(resume.created).fromNow() !== "Invalid date"
                        ? moment(resume.created).fromNow()
                        : moment("2022-03-31T06:26:04.138Z").fromNow()
                      : moment("2022-03-31T06:26:04.138Z").fromNow()}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Radio
                    {...controlProps(resume)}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 24,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default ResumesList;
